module.exports = __webpack_public_path__ + "img/menu_7.58d5809d.png";